import {Axios} from "axios";
import {UserDto, UserRoleType} from "./User";
import {PageableDto} from "../pagination/PagingFilterDto";
import {SortableDto} from "../pagination/SortingFilterDto";
import {PageableResultListDto} from "../pagination/PageableResultListDto";

export interface UserFilterDto extends PageableDto, SortableDto {
    loginLike?: string;
    firstNameLike?: string;
    lastNameLike?: string;
    emailLike?: string;
}

export class UserApiClient {

    constructor(private readonly axios: Axios) {
    }

    findByLogin(login: string): Promise<UserDto | undefined> {
        return new Promise((resolve, reject) => {
            this.axios.get<UserDto | undefined>(`/users/${login}`)
                .then((response) => resolve(response.data))
                .catch((error) => {
                    if (error?.response?.status === 404) {
                        resolve(undefined);
                    }
                    reject(error);
                });
        });
    }

    findMe(): Promise<UserDto | undefined> {
        return new Promise((resolve, reject) => {
            this.axios.get<UserDto | undefined>(`/users/me`)
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    findMyValidRoles(): Promise<UserRoleType[]> {
        return new Promise((resolve, reject) => {
            this.axios.get<string[]>(`/users/me/roles`)
                .then((response) => resolve(response.data as UserRoleType[]))
                .catch((error) => reject(error));
        });
    }

    findByFilter(filter: UserFilterDto): Promise<PageableResultListDto<UserDto>> {
        return new Promise((resolve, reject) => {
            this.axios.post<PageableResultListDto<UserDto>>("/users:search", filter)
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    countByFilter(filter: UserFilterDto): Promise<number> {
        return new Promise((resolve, reject) => {
            this.axios.post<number>("/users:count", filter)
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }
}
